<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.content }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (showCancelButton) {
    <button mat-button (click)="onNoClick()">
      {{ cancelButtonText }}
    </button>
  }
  
  <button mat-raised-button color="primary" (click)="onYesClick()" cdkFocusInitial>
    {{ confirmButtonText }}
  </button>
</mat-dialog-actions>